/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RecipeResponseDto } from '../../models/recipe-response-dto';
import { SetRecipeDto } from '../../models/set-recipe-dto';

export interface RecipeControllerSetRecipe$Params {
  id: string;
      body: SetRecipeDto
}

export function recipeControllerSetRecipe(http: HttpClient, rootUrl: string, params: RecipeControllerSetRecipe$Params, context?: HttpContext): Observable<StrictHttpResponse<RecipeResponseDto>> {
  const rb = new RequestBuilder(rootUrl, recipeControllerSetRecipe.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecipeResponseDto>;
    })
  );
}

recipeControllerSetRecipe.PATH = '/products/{id}/recipe';
